import { Controller } from "stimulus";
import _ from 'lodash';

class LiveTickerModuleController extends Controller {
  static targets = [
    'symbol',
    'legalName',
    'lastPrice',
    'netAssets',
    'expenseRatio',
    'priceAsOfDate',
    'ticker'
  ]

  initialize() {
    this.intradayPrice = this.data.get('intradayPrice') || 'false';
    this.tickerList = this._processedDataFromSource();
    this.filterTickerRows();
    this.updateLTMData();
  }

  filterTickerRows = () => {
    if (this.hasTickerTarget) {
      this.tickerTargets.forEach(tickerDom => {
        const [ticker] = this.tickerList.filter(ticker => ticker.symbol === tickerDom.getAttribute('data-symbol'));
        if (!ticker) {
          tickerDom.remove();
        }
      })
    }
  }

  updateLTMData = () => {
    this.replaceTargetWithValue('symbol', ticker => _.isEmpty(ticker.symbol) ? '-' : ticker.symbol);
    this.replaceTargetWithValue('legalName', ticker => _.isEmpty(ticker.legal_name) ? '-' : ticker.legal_name.replace('®', '\<sup\>®\</sup\>'));
    this.replaceTargetWithValue('lastPrice', ticker => {
      if (this.intradayPrice == 'true') {
        return _.isNil(ticker.intraday_price) ? '-' : '$' + ticker.intraday_price
      }
      return _.isNil(ticker.last_price) ? '-' : '$' + ticker.last_price
    });
    this.replaceTargetWithValue('netAssets', ticker => _.isEmpty(ticker.net_assets) ? '-' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting', notation: "compact" }).format(ticker.net_assets));
    this.replaceTargetWithValue('expenseRatio', ticker => _.isEmpty(ticker.expense_ratio) ? '-' : new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2 }).format(ticker.expense_ratio / 100));
    this.replaceTargetWithValue('priceAsOfDate', ticker =>  _.isEmpty(ticker.price_as_of) ? '-' : new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(new Date(ticker.price_as_of)));
  }

  replaceTargetWithValue = (targetName, replaceFunction) => {
    const hasTargetString = _.camelCase(`has ${targetName} target`);
    const targetsString = _.camelCase(`${targetName} targets`);
    if (this[hasTargetString]) {
      this[targetsString].forEach(target => {
        const [ticker] = this.tickerList.filter(ticker => ticker.symbol === target.getAttribute('data-symbol'));
        if (ticker) {
          target.innerHTML = replaceFunction(ticker);
        } else {
          target.innerHTML = '-';
        }
      })
    }
  }

  _processedDataFromSource = () => {
    const symbols = this.data.get('symbols').split(',');
    const { cachedSecurities, ltms } = window.MConstants;
    let symbolChangeDiffs = {}
    Object.values(ltms).map(ltm => {
      const syms = ltm['symbols']
      syms.forEach(s => {
        symbolChangeDiffs[s] = ltm['change_diff']
      })
    })

    return cachedSecurities.map(security => security.data).filter(security => {
      return symbols.includes(security.symbol) && security.changes >= parseFloat(symbolChangeDiffs[security.symbol] || '-1000')
    });
  }
}
export default LiveTickerModuleController;
